import v5_Model from '@/models/v5/model';
import Api from '@/lib/api/api';

var DevCounts = v5_Model.extend({
    initialize: function () {
        this.type = DevCounts.type;
    },
    url: function () { return Api.urls.devcounts({ product_id: this.get('product').id }); },

});

DevCounts.type = 'devcounts';

export default DevCounts;

